import React from "react"
import Heading from "./Heading"
import { Link } from "gatsby"
import BackgroundImage from "gatsby-background-image"

export default function InfoBlock({ heading, photo }) {
  return (
    <BackgroundImage className="section my-4 py-4" fluid={photo}>
      <div className="container">
        <Heading title={heading} className="text-warning" />
        <div className="row">
          <div className="col-10 col-sm-8 mx-auto text-center">
            <p className="lead text-white mb-4">
              Lorem ipsum dolor sit amet consectetur adipisicing elit. Velit
              fuga veritatis voluptates vero soluta sint incidunt, similique
              quos dolor consequatur suscipit repellendus, distinctio officia
              voluptatum labore iure impedit quidem veniam dolores. Praesentium
              iure quasi officia eum pariatur asperiores aspernatur quod.
              Accusamus exercitationem vel quas placeat inventore animi saepe
              accusantium vero quo, a quis corrupti perspiciatis modi! Atque
              labore optio officia.
            </p>
            <Link to="/about">
              <button className="btn btn-warning btn-lg">{heading}</button>
            </Link>
          </div>
        </div>
      </div>
    </BackgroundImage>
  )
}
